import React from 'react';
import { ConfirmDialog } from '@personal-dashboard/ui';

interface DeleteWidgetDialogProps {
  open: boolean;
  widgetTitle: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteWidgetDialog: React.FC<DeleteWidgetDialogProps> = ({
  open,
  widgetTitle,
  loading,
  onConfirm,
  onCancel,
}) => {
  return (
    <ConfirmDialog
      open={open}
      title="Delete Widget"
      message={`Delete the "${widgetTitle}" widget? This only removes the widget configuration — your underlying custom field data is preserved.`}
      confirmLabel="Delete"
      severity="error"
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default DeleteWidgetDialog;
